import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import PropTypes from 'prop-types';

const DatePicker = ({
  helper,
  label,
  error,
  value,
  slotProps,
  ...props
}) => {
  return (
    <MUIDatePicker
      label={label}
      value={value || null}
      slotProps={{
        textField: {
          error,
          helperText: helper,
        },
        ...slotProps,
      }}
      {...props}
    />
  );
};

DatePicker.propTypes = {
  helper: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
};

export default DatePicker;
